import { useAnalytics } from "../../providers/AnalyticsProvider"
import { getDatesBetween } from "../../utils/time"
import { DateTypeToFloat } from "../../utils/TimeUtils"

export default function UsersTable() {
    const { userData, timeframe, searchDate } = useAnalytics()
    const start = DateTypeToFloat(searchDate?.startDate ?? new Date(), true)
    const end = DateTypeToFloat(searchDate?.endDate ?? new Date(), false)
    const labels = getDatesBetween(start, end, timeframe)

    return (<>
        {userData && <div className="overflow-visible border border-gray-300 ring-opacity-5 rounded-md max-w-full overflow-y-auto thin-scrollbar thin-scrollbar-x mt-4">
            <table className="table-fixed min-w-full max-w-full divide-y divide-gray-600 rounded-md">
                <thead className="bg-gray-50 sticky top-0 z-10 border-b-2 border-gray-300">
                    <tr className="bg-gray-50">
                        <th className="sticky bg-gray-50 left-0 max-w-[178px] z-[99] px-4 py-3.5 text-left text-xs sm:text-sm font-semibold text-gray-900 border-none">
                            User
                        </th>
                        <th className="sticky bg-gray-50 left-[178px] max-w-[96px] z-[98] px-4 py-3.5 text-center text-xs sm:text-sm font-semibold text-gray-900 border-r border-gray-400">
                            Total
                        </th>
                        {labels.map((label) => (
                            <th
                                key={label}
                                scope="col"
                                className="max-w-[96px] py-3.5 px-4 text-xs sm:text-sm font-semibold text-gray-900 text-center"
                            >
                                {label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(userData).length > 0 &&
                        Object.keys(userData).map((user, index) => (
                            <tr key={index}>
                                <td className="sticky left-0 max-w-[178px] z-0 bg-white px-4 py-4 text-xs sm:text-sm text-gray-900 border-none">
                                    {user}
                                </td>
                                <td className="sticky left-[178px] max-w-[96px] z-0 bg-white px-4 py-4 text-xs sm:text-sm text-gray-900 text-center border-r border-gray-200">
                                    {userData[user]["Total"]}
                                </td>
                                {labels.map((date) => (
                                    <td
                                        key={date}
                                        className="max-w-[96px] whitespace-nowrap px-4 py-4 text-xs sm:text-sm font-medium text-gray-900 text-center"
                                    >
                                        {userData[user][date]}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    {Object.keys(userData).length === 0 && (
                        <tr>
                            <td
                                colSpan={labels.length + 2}
                                className="border px-4 py-8 text-center"
                            >
                                No Data
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>}
    </>)
}